module.exports = {
  className: 'EWallet',
  classNameLabel: 'E-wallet',
  limit: 10,
  showExport: false,
  columns: [
    {
      columnName: 'objectId',
      type: 'string',
    },
    {
      columnName: 'image',
      columnLabel: 'Image',
      type: 'ParseFile',
    },
    {
      columnName: 'walletCode',
      columnLabel: 'wallet code',
      type: 'string',
    },
    {
      columnName: 'walletName',
      columnLabel: 'wallet Name',
      type: 'string',
    },
    {
      columnName: 'isShowWallet',
      columnLabel: 'show wallet',
      type: 'boolean',
    },
    {
      columnName: 'isHideZeroBal',
      columnLabel: 'Hide Zero Bal',
      type: 'boolean',
    },
    {
      columnName: 'imageSize',
      type: 'string',
      show: false,
    },
    {
      columnName: 'sort',
      type: 'number',
      style: {
        whiteSpace: 'normal',
        minWidth: '130px',
      },
    },
    {
      columnName: 'startDate',
      columnLabel: 'START DATE',
      type: 'Date',
      format: 'MMM D, YYYY hh:mm A',
      show: false,
    },
    {
      columnName: 'endDate',
      columnLabel: 'END DATE',
      type: 'Date',
      format: 'MMM D, YYYY hh:mm A',
      show: false,
    },
    {
      columnName: 'createdAt',
      type: 'Date',
    },
    {
      columnName: 'updatedAt',
      type: 'Date',
    },
  ],
};



// WEBPACK FOOTER //
// ./components/EWallet/EWallet.js